import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3ca7f1d3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "refund-box"
};
const _hoisted_2 = {
  class: "refund-tit"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ifream-box"
}, [/*#__PURE__*/_createElementVNode("iframe", {
  class: "ifream",
  src: "https://m.modian.com/about/about_index/3/15"
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompPopupBottom = _resolveComponent("CompPopupBottom");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_CompPopupBottom, {
    show: $props.show
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("i", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.closePopup && $options.closePopup(...args))
    })]), _hoisted_3])]),
    _: 1
  }, 8, ["show"])]);
}